import {DeploymentDataEntry, Job, MeasurementType} from "../dtos/dtos";

export enum DataEntryClassification {
    valid = 0,
    geoFencingExceeded = 20,
    oxygenSaturationRangeExceeded = 30,
    oxygenErrorCode = 31,
    temperatureRangeExceeded = 40,
    temperatureErrorCode = 41,
    conductivityRangeExceeded = 50,
    conductivityErrorCode = 51
}

export const dataEntryClassificationText = {
    [DataEntryClassification.valid]: "valid",
    [DataEntryClassification.geoFencingExceeded]: "Geo Fencing",
    [DataEntryClassification.oxygenSaturationRangeExceeded]: "Oxygen saturation range exceeded",
    [DataEntryClassification.oxygenErrorCode]: "Oxygen error code",
    [DataEntryClassification.temperatureRangeExceeded]: "Temperature range exceeded",
    [DataEntryClassification.temperatureErrorCode]: "Temperature error code",
    [DataEntryClassification.conductivityRangeExceeded]: "Conductivity range exceeded",
    [DataEntryClassification.conductivityErrorCode]: "Conductivity error code"
};

export const validRanges = {
    [MeasurementType.OxygenTemperature]: {
        min: -5,
        max: 30
    },
    [MeasurementType.OxygenSaturation]: {
        min: 0,
        max: 150
    },
    [MeasurementType.Conductivity]: {
        min: 100,
        max: 100000
    }
}

export function hasErrorForType(type: MeasurementType, errors: DataEntryClassification[]): boolean {
    return (
        (type === MeasurementType.OxygenSaturation && (errors.includes(DataEntryClassification.oxygenSaturationRangeExceeded) || errors.includes(DataEntryClassification.oxygenErrorCode))) ||
        (type === MeasurementType.OxygenTemperature && (errors.includes(DataEntryClassification.temperatureRangeExceeded) || errors.includes(DataEntryClassification.temperatureErrorCode))) ||
        (type === MeasurementType.Conductivity && (errors.includes(DataEntryClassification.conductivityRangeExceeded) || errors.includes(DataEntryClassification.conductivityErrorCode))));
}

export const geoFencingTolerance = 0.0015; // appr 150m W / 100m N


export function classifyDataEntry(dataEntry: DeploymentDataEntry, job?: Job): DataEntryClassification[] {
    const errors: DataEntryClassification[] = [];
    if (job && dataEntry.gpsCoordinates?.latitude !== undefined && dataEntry.gpsCoordinates?.longitude !== undefined &&
        (dataEntry.gpsCoordinates.latitude < job.latitude - geoFencingTolerance || dataEntry.gpsCoordinates.latitude > job.latitude + geoFencingTolerance ||
            dataEntry.gpsCoordinates.longitude < job.longitude - geoFencingTolerance || dataEntry.gpsCoordinates.longitude > job.longitude + geoFencingTolerance)) {
        errors.push(DataEntryClassification.geoFencingExceeded);
    }
    for (const measurement of dataEntry.measurements) {
        if (measurement.type === MeasurementType.OxygenSaturation) {
            if (measurement.statusCode !== 0) {
                errors.push(DataEntryClassification.oxygenErrorCode);
            } else if (validRanges[MeasurementType.OxygenSaturation].min > measurement.value || validRanges[MeasurementType.OxygenSaturation].max < measurement.value) {
                errors.push(DataEntryClassification.oxygenSaturationRangeExceeded);
            }
        }
        if (measurement.type === MeasurementType.OxygenTemperature) {
            if (measurement.statusCode !== 0) {
                errors.push(DataEntryClassification.temperatureErrorCode);
            } else if (validRanges[MeasurementType.OxygenTemperature].min > measurement.value || validRanges[MeasurementType.OxygenTemperature].max < measurement.value) {
                errors.push(DataEntryClassification.temperatureRangeExceeded);
            }
        }
        if (measurement.type === MeasurementType.Conductivity) {
            if (measurement.statusCode !== 0) {
                errors.push(DataEntryClassification.conductivityErrorCode);
            } else if (validRanges[MeasurementType.Conductivity].min > measurement.value || validRanges[MeasurementType.Conductivity].max < measurement.value) {
                errors.push(DataEntryClassification.conductivityRangeExceeded);
            }
        }
    }
    return errors.length === 0 ? [DataEntryClassification.valid] : errors;
}
